// extracted by mini-css-extract-plugin
module.exports = {"foldersRow":"src-modules-project-components-FoldersManagementModel---foldersRow---1XGCO"};